import moment from 'moment-timezone';

const getTimezoneFromAddressFromTimeKey = (key) => {
  const fromTimeToTimezoneKey = {
    pickup_time_from: 'pickup_timezone',
    pickup_time_to: 'pickup_timezone',
    dropoff_time_from: 'dropoff_timezone',
    dropoff_time_to: 'dropoff_timezone',
  };

  return fromTimeToTimezoneKey[key] || moment.tz.guess();
};

export default getTimezoneFromAddressFromTimeKey;
